﻿import React, { useState, useEffect } from 'react';
import { pushToDataLayer } from '../dataLayer'
import { useDebounce } from '../hooks/useDebounce'

export const InputWithLabel = (props) => {
  const wrappingClass = `single-step__section single-step__section--${(props.inputType === 'quantity' ? "number" : props.inputType) || "text"}${(props.toUpperCase ? ' single-step__section--uppercase' : "")}`;

  const inputType = props.inputType ? props.inputType !== 'ssn' && props.inputType !== 'email' && props.inputType !== 'organisation' ? props.inputType : 'text' : 'text';
  const inputTypeNumberProps = props.inputType === 'number' || props.inputType === 'quantity' ? { min: 1, step: 1, pattern: "\d+" } : null;
  const error = props.value?.error ?? null;
  const value = props.value?.text ?? null;
  const defaultValue = props.defaultText !== null ? typeof props.defaultText === 'object' ? props.defaultText.text ?? '' : props.defaultText : '';
  const useExtendedSupport = extendedSupport();

  const [inputValue, setInputValue] = useState(props.inputType === 'quantity' && !value ? '1' : value);
  const debouncedInputValue = useDebounce(inputValue, props.debounce ?? 0);

  useEffect(() => {
    //if (!debouncedInputValue)
    //  return;
    if(props.onChange) {
      props.onChange(props.index, debouncedInputValue);
      pushToDataLayer({ event: 'input_change', label: props.text, value: debouncedInputValue }, 1000);
    } else {
      if (!props.setValue)
        return;

      if (useExtendedSupport && debouncedInputValue && inputType === 'time') {
        const value = debouncedInputValue.match(/\d+/g)?.join('') ?? '';

        if (value.length === 4) {
          const outputHours = value.substring(0, 2);
          const outputMinutes = value.substring(2);

          if (parseInt(outputHours, 10) > 24 || parseInt(outputMinutes, 10) > 59)
            return;

          props.setValue({...props.value, text: `${outputHours}:${outputMinutes}`});

          return;
        } else if (debouncedInputValue.length >= 5) {
          return;
        }
      }

      const value = ((props.inputType === 'number' || props.inputType === 'quantity') && debouncedInputValue) ? `${debouncedInputValue}`.match(/\d+/g)?.join('') : debouncedInputValue;

      props.setValue({ ...props.value, text: value })
    }
  }, [debouncedInputValue])

  useEffect(() => {
    setInputValue(props.inputType === 'quantity' && (value === '0') ? '1' : value);
  }, [value])

  return (
    <div className={wrappingClass}>
      <label>
        {props.text && <span className={['single-step__section__label', props.displayAsText ? 'single-step__section__label--small' : ''].join(' ')}>{props.text}
          {props.description && <span> {props.description}</span>}</span>}
        {props.displayAsText && <div className="single-step__section__text">{value}</div>}
        {!props.displayAsText && <input
          type={inputType === 'quantity' ? 'number' : inputType}
          inputMode={inputType === 'quantity' || inputType === 'number' ? "numeric" : "text"}
          aria-invalid={error ? true : null}
          onKeyDown={(e) => props.keyDown ? props.keyDown(e) : null}
          placeholder={props.placeholder}
          autoComplete={props.autocomplete}
          onChange={(e) => setInputValue(e.target.value)}
          // defaultValue={defaultValue}
          value={inputValue ?? defaultValue ??''}
          disabled={props.disabled}
          autoFocus={props.autoFocus}
          maxLength={props.maxLength}
          name={props.name ?? ""}
          {...inputTypeNumberProps} />}
        {error && <div className="validation-error">{error}</div>}
      </label>
    </div>
  );
}

const extendedSupport = () => {
  if (window.document.documentMode)
    return true;

  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') === -1)
    return true;

  return false;
}